import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import getAPI from "../../service/getAPI";

function Sidebar() {
  const { master } = getAPI();
  const location = useLocation();
  const [departmentOpen, setDepartmentOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [storeList, setStoreList] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [dateFilterType, setDateFilterType] = useState("today"); // or default value as needed

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const toggleDepartment = () => {
    setDepartmentOpen(!departmentOpen);
  };

  useEffect(() => {
    setDepartmentOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const toggleSidebar = () => {
      document.body.classList.toggle("toggle-sidebar");
    };

    const sidebarButton = document.querySelector(".toggle-sidebar-btn");
    if (sidebarButton) {
      sidebarButton.addEventListener("click", toggleSidebar);
    }

    return () => {
      if (sidebarButton) {
        sidebarButton.removeEventListener("click", toggleSidebar);
      }
    };
  }, []);

  const fetchDashboardData = (storeId, filterType) => {
    // define this function as per your app's logic
    console.log("Fetching dashboard data for:", storeId, filterType);
  };

  const fetchStoreList = async (adminStoreId = null, isStore = false, storeId = null) => {
    try {
      const requestData = { pageIndex: 1, pageSize: 100 };
      const res = await axios.post(master.storelist_all, requestData);
      if (res.data.flag === 1) {
        const list = res.data.data.filter(
          (store) => store.is_active === 1 || store.is_active === true
        );
        setStoreList(list);

        if (list.length > 0) {
          if (isStore && storeId) {
             setSelectedStoreId(storeId);
          } else {
             const adminStore = list.find((s) => s.store_id === adminStoreId);
             const defaultStoreId = adminStore ? adminStore.store_id : list[0].store_id;
             setSelectedStoreId(defaultStoreId);
          }
        }
      }
    } catch (err) {
      console.error("Error fetching stores:", err);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    let adminStoreId = null;
    let isStore = false;
    let storeId = null;

    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      isStore = parsed.type === "store" || parsed.user_type === "store";
      storeId = parsed.id || parsed.store_id;

      if (!isStore) {
        adminStoreId = storeId;
      }
    }
    fetchStoreList(adminStoreId, isStore, storeId);
  }, []);

  useEffect(() => {
    console.log("Current pathname:", location.pathname);
  }, [location.pathname]);

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">

        {/* Dashboard */}
        <Link className={`nav-link ${location.pathname === "/admin/dashboard" ? "active" : "collapsed"}`} to="/admin/dashboard">
          <i className="bi bi-speedometer2"></i>
          <span>Dashboard</span>
        </Link>

        {/* Order List */}
        <Link className={`nav-link ${location.pathname === "/admin/orderList" ? "active" : "collapsed"}`} to="/admin/orderList">
          <i className="bi bi-card-list"></i>
          <span>Order List</span>
        </Link>

        {/* 🟢 NEW: Products */}
        <Link className={`nav-link ${location.pathname === "/admin/products" ? "active" : "collapsed"}`} to="/admin/products">
          <i className="bi bi-box-seam"></i>
          <span>Products</span>
        </Link>

        {/* 🟢 NEW: POS */}
        <Link className={`nav-link ${location.pathname === "/admin/pos" ? "active" : "collapsed"}`} to="/admin/pos">
          <i className="bi bi-cart-plus"></i>
          <span>Create Order (POS)</span>
        </Link>

        {/* Customers */}
        <Link className={`nav-link ${location.pathname === "/admin/customer" ? "active" : "collapsed"}`} to="/admin/customer">
          <i className="bi bi-people"></i>
          <span>Customers</span>
        </Link>

        {/* 🟢 NEW: Manage Branches (Admin Branch only) */}
        {(user?.user_type === "admin" || user?.store_id === 1 || localStorage.getItem("store_id") === "1" || localStorage.getItem("user_type") === "admin") && (
          <Link className={`nav-link ${location.pathname === "/admin/stores" ? "active" : "collapsed"}`} to="/admin/stores">
            <i className="bi bi-shop"></i>
            <span>Manage Branches</span>
          </Link>
        )}

        {/* 🟢 Free Product Offers */}
        <Link className={`nav-link ${location.pathname === "/admin/free-product-offers" ? "active" : "collapsed"}`} to="/admin/free-product-offers">
          <i className="bi bi-gift"></i>
          <span>Free Product Offers</span>
        </Link>

        {/* 🟢 Configuration (Admin only) */}
        {(user?.user_type === "admin" || localStorage.getItem("user_type") === "admin") && (
          <Link className={`nav-link ${location.pathname === "/admin/configuration" ? "active" : "collapsed"}`} to="/admin/configuration">
            <i className="bi bi-gear"></i>
            <span>Configuration</span>
          </Link>
        )}

        {/* 🟢 Branch Profile & Settings */}
        <Link className={`nav-link ${location.pathname === "/admin/profile" ? "active" : "collapsed"}`} to="/admin/profile">
          <i className="bi bi-person-gear"></i>
          <span>Branch Profile & Settings</span>
        </Link>

      </ul>
    </aside>
  );
}

export default Sidebar;
